import sc from 'styled-components';
import {Select, UnifonTheme} from '@phonectas/unifon-ui-kit';

interface StyledSelectRequiredProps {
    required?: boolean;
    theme?: UnifonTheme;
}

export const StyledSelectRequired = sc(Select)<StyledSelectRequiredProps>`
    ${props => props.required && `
        & button {
            outline: 1px solid ${props.theme?.palette?.error || 'red'};
        }
    `};
`;
